import styled, { css } from 'styled-components';

import { getThemeColor } from '@utils/styled';

import LazyImg from '@common/components/LazyImg';
import { SectionTitle } from '../Content.styled';

const THUMBNAIL_SIZE_REM = 5;
const THUMBNAIL_BORDER_WIDTH_REM = 0.2;

export const Thumbnail = styled(LazyImg)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: ${THUMBNAIL_SIZE_REM}rem;
  max-width: ${THUMBNAIL_SIZE_REM}rem;
  min-height: ${THUMBNAIL_SIZE_REM}rem;
  max-height: ${THUMBNAIL_SIZE_REM}rem;
  background-color: ${getThemeColor('bluegrey.95')};

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  picture {
    min-width: ${THUMBNAIL_SIZE_REM}rem;
    max-width: ${THUMBNAIL_SIZE_REM}rem;
    min-height: ${THUMBNAIL_SIZE_REM}rem;
    max-height: ${THUMBNAIL_SIZE_REM}rem;
  }
`;

export const ThumbnailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, ${THUMBNAIL_SIZE_REM}rem);
  ${({ theme }) => theme.getFluidSpacing('grid-gap', 'equal', 5)}
`;

export const ThumbnailLink = styled.a`
  min-width: ${THUMBNAIL_SIZE_REM}rem;
  outline: none;
  padding: 0;
  background: none;
  cursor: pointer;

  ${Thumbnail} {
    ${({ isSelected }) =>
      isSelected
        ? css`
            outline: ${THUMBNAIL_BORDER_WIDTH_REM}rem solid
              ${getThemeColor('hue.lightBlue')};
            outline-offset: ${THUMBNAIL_BORDER_WIDTH_REM * -1}rem;
          `
        : css`
            outline: none;
            outline-offset: 0;
            background-color: transparent;
          `};
  }
`;

export const ColorValue = styled(SectionTitle).attrs({ customAs: 'span' })`
  display: inline-block;
  margin: 0;
  font-weight: 500;
`;
